<section class="service-intro content-wrapper">
  <div class="service-content">
    <h1 class="title">
      Professional Graphic Design & Branding Agency in Goa (India) & Globally
    </h1>
    <p class="description">
      Geekeno delivers expert graphic design services in Goa, helping brands
      across India and globally stand out with impactful visuals. From logo
      design and brochure creation to packaging design and full brand identity
      systems, we craft creative, strategic, and results-driven designs that
      connect with your audience and elevate your brand.
    </p>
  </div>
  <div class="decorative-elements is-hidden-touch">
    <img
      src="/assets/services/deco-element.png"
      loading="eager"
      fetchpriority="high"
      width="265"
      height="400"
      alt=""
      role="presentation"
    />
  </div>
</section>

<section class="services">
  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/graphic-design/logo-design.avif"
        loading="eager"
        fetchpriority="high"
        width="445"
        height="431"
        alt="Logo design for Goa-based startup"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Logo Designing — Stand Out, Everywhere</h2>
      <p class="service-description">
        Our logo design services in Goa are tailored to reflect your brand's
        personality and values. We create scalable, memorable logos that look
        sharp across print, web, and social platforms — perfect for startups and
        established brands alike.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
  <div class="service-row reverse content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/graphic-design/brochure-design.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="Brochure layout for hospitality brand"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">Brochure Design — Inform, Persuade, Convert</h2>
      <p class="service-description">
        Geekeno designs brochures that tell your story with clarity and style.
        Whether it's a corporate profile, tourism brochure, or product
        catalogue, we combine engaging layouts with strategic messaging to drive
        action.
      </p>
    </div>
  </div>

  <div class="service-divider"></div>
  <div class="service-row content-wrapper">
    <div class="service-image">
      <img
        src="/assets/services/graphic-design/package-design.avif"
        loading="lazy"
        width="445"
        height="431"
        alt="Eco-friendly packaging design for skincare product"
        role="presentation"
      />
    </div>
    <div class="service-content">
      <h2 class="service-title">
        Packaging Design — Make Every First Impression Count
      </h2>
      <p class="service-description">
        - Your packaging is your first impression. We create eye-catching,
        functional packaging designs that stand out on shelves and online — with
        options for sustainable materials and brand-aligned aesthetics.
      </p>
    </div>
  </div>
  <div class="service-divider"></div>
</section>
